import type { ComputerViewModelExtended } from './computer-view-model-extended';
import { mobileMedicalDataRequirements } from './mobile-medical-data-requirements';
import { t } from 'src/i18n';

/**
 * Defines the rules for a computer. A rule as consists of a test that given a
 * computer, determines if this rule is violated and a message function
 * that creates the error message.
 *
 * There is also an id field. this is used when testing the rules.
 *
 * @type {Array}
 */
export const rulesForComputers = [
  {
    id: 1,
    test: function (c: ComputerViewModelExtended): boolean {
      return (
        (c.unitType === 'computer' || c.unitType === '') &&
        c.hasMedicalData &&
        c.type === 'mobile' &&
        (c.mobileMedicalDataRequirements ?? []).length !== mobileMedicalDataRequirements().length
      );
    },
    message: function (): string {
      return t('computers.alertMobileMedicalDataRequirementsNotMet');
    },
  },
];
